import { DataGrid, DataGridProps } from '@chipinside/datagrid/dist'

export function DataGridWrapper(props) {
  const controller: DataGridProps['controller'] = {
    endpoint: () => props.controller,
  }

  // TODO: Remover quando o backend controlar as utilities
  return (
    <>
      <style>
        {`
          .datagrid-utility-refresh,
          .datagrid-utility-seeder,
          .datagrid-utility-settings {
            display: none;
          }
        `}
      </style>
      <DataGrid {...props} controller={controller} elevation={0} withoutQueryParamsOnUrl />
    </>
  )
}
